export const DATABASE_CONTENT_TYPE = 'database';

export const DEFAULT_VIEW_NAME = 'View 1';

/** Columns in table view mode cannot be resized to anything more narrow than this */
export const TABLE_VIEW_HARD_COLUMN_MIN_WIDTH = 85;
/** Columns in table view mode with undefined width will have this minimum width applied */
export const TABLE_VIEW_SOFT_COLUMN_MIN_WIDTH = 200;

/** Number of times that a database value may reference another database value before breaking the recursion */
export const RECURSION_LIMIT = 10;

/** The pixel size used to keep the left half of the row select button shown during scroll */
export const HALF_ROW_SELECT_BUTTON_WIDTH = 9;

export const NUMBERED_COLUMN_WIDTH = 50;
